module.exports = __webpack_public_path__ + "static/media/trimex_hojadeoro.439ab22d.png";